@if (editable()) {
  <span class="percent-box percent-box--edit">
    @if (nullable() && !isNetDisabled()) {
      <i
        aria-hidden="true"
        (click)="toggleNullableNet()"
        class="pi percent-box__toggle"
        [class.pi-minus]="isNull()"
        [class.pi-check-circle]="!isNull()"
      ></i>
    }
    @if (!isNull()) {
      <input
        pInputText
        [disabled]="isNetDisabled()"
        [ngModel]="net | currency"
        (ngModelChange)="net = $event"
        (keyup)="calculateTotals(); netValueChanged()"
        (keyup.enter)="saveEmit()"
        type="text"
        inputmode="decimal"
        step="0.5"
        class="form-control percent-box__input"
        data-cy="net-price"
      />
      <input
        pInputText
        [disabled]="isMarginAndTotalDisabled()"
        [ngModel]="margin | currency"
        (ngModelChange)="margin = $event"
        (keyup)="limitMargin(); calculateTotals(); marginValueChanged()"
        (keyup.enter)="saveEmit()"
        type="text"
        inputmode="decimal"
        step="0.5"
        class="form-control percent-box__input"
        data-cy="margin-price"
      />
      <span class="percent-box__sep">%</span>
      <i class="pi pi-chevron-right percent-box__sep"></i>
      <input
        pInputText
        [disabled]="isMarginAndTotalDisabled()"
        [ngModel]="total | currencyRound"
        (ngModelChange)="total = $event"
        (keyup)="calculateMarginFromTotal()"
        (keyup.enter)="saveEmit()"
        type="text"
        inputmode="decimal"
        step="0.5"
        class="form-control percent-box__input"
        data-cy="total-price"
      />
    }
  </span>
} @else if (shouldDisplayDash()) {
  <span class="percent-box">&mdash;</span>
} @else if (!displayMargin()) {
  <span class="percent-box">{{ net | currency }}</span>
} @else {
  <span class="percent-box">
    <span class="percent-box__value">{{ net | currency }}</span>
    <span class="percent-box__value">{{ margin | forceSign }}%</span>
    <i class="pi pi-chevron-right percent-box__sep"></i>
    <span class="percent-box__total">{{ total | currencyRound }}</span>
  </span>
}
